import React, { useState, useEffect } from "react";
import { Outlet, NavLink, useNavigate } from "react-router-dom";
import api from "../../services/api";
import { LayoutDashboard, Users, ClipboardList, FileText, Settings, LogOut, Menu, X, Table2, PlusCircle } from "lucide-react";

const navItems = [
  { to: "/admin", icon: LayoutDashboard, label: "Dashboard", end: true },
  { to: "/admin/initiate", icon: PlusCircle, label: "New Assessment" },
  { to: "/admin/users", icon: Users, label: "Users" },
  { to: "/admin/executions", icon: ClipboardList, label: "Executions" },
  { to: "/admin/assessments", icon: FileText, label: "Assessments" },
  { to: "/admin/data-tables", icon: Table2, label: "Data Tables" },
  { to: "/admin/settings", icon: Settings, label: "Settings" },
];

export default function AdminLayout() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const navigate = useNavigate();
  const user = api.getUser();

  useEffect(() => { if (!user || user.role !== "admin") navigate("/admin/login"); }, [user, navigate]);

  if (!user || user.role !== "admin") return null;

  return (
    <div className="min-h-screen bg-gray-50 flex">
      <aside className={`fixed inset-y-0 left-0 z-50 w-64 bg-white border-r border-gray-200 transform transition-transform lg:translate-x-0 lg:static ${sidebarOpen ? "translate-x-0" : "-translate-x-full"}`}>
        <div className="flex items-center justify-between h-16 px-6 border-b border-gray-200">
          <span className="text-lg font-bold text-gray-900">ESG Admin</span>
          <button onClick={() => setSidebarOpen(false)} className="lg:hidden text-gray-400"><X className="w-5 h-5" /></button>
        </div>
        <nav className="p-4 space-y-1">
          {navItems.map(item => (
            <NavLink key={item.to} to={item.to} end={item.end} onClick={() => setSidebarOpen(false)}
              className={({ isActive }) => `flex items-center gap-3 px-4 py-3 rounded-lg text-sm font-medium transition-colors ${isActive ? "bg-emerald-50 text-emerald-700" : "text-gray-600 hover:bg-gray-50 hover:text-gray-900"}`}
              data-testid={`admin-nav-${item.label.toLowerCase()}`}>
              <item.icon className="w-5 h-5" />{item.label}
            </NavLink>
          ))}
        </nav>
        <div className="absolute bottom-0 left-0 right-0 p-4 border-t border-gray-200">
          <div className="flex items-center gap-3 px-4 py-2 mb-2">
            <div className="w-8 h-8 rounded-full bg-emerald-600 flex items-center justify-center text-white text-sm font-bold">{user.full_name?.[0] || "A"}</div>
            <div className="flex-1 min-w-0"><p className="text-sm font-medium text-gray-900 truncate">{user.full_name}</p><p className="text-xs text-gray-500 truncate">{user.email}</p></div>
          </div>
          <button data-testid="admin-logout-btn" onClick={() => { api.clearAuth(); navigate("/admin/login"); }}
            className="flex items-center gap-3 w-full px-4 py-2 rounded-lg text-sm text-red-600 hover:bg-red-50 transition-colors"><LogOut className="w-4 h-4" />Logout</button>
        </div>
      </aside>
      {sidebarOpen && <div className="fixed inset-0 bg-black/20 z-40 lg:hidden" onClick={() => setSidebarOpen(false)} />}
      <div className="flex-1 flex flex-col min-w-0">
        <header className="h-16 border-b border-gray-200 flex items-center px-6 bg-white">
          <button onClick={() => setSidebarOpen(true)} className="lg:hidden text-gray-400 mr-4"><Menu className="w-5 h-5" /></button>
          <h2 className="text-gray-900 font-medium">Administration Panel</h2>
        </header>
        <main className="flex-1 p-6 overflow-auto"><Outlet /></main>
      </div>
    </div>
  );
}
